<template>
  <div class="container-fluid bg-light">
    <div class="row justify-content-center align-items-center min-vh-100">
      <div class="col">
        <div class="card shadow">
          <img src="@/assets/images/logo-wide-black.png" class="card-img-top pt-4 px-4" />
          <div class="card-body">
            <h4 class="card-title text-center">Forgot Password</h4>
            <p class="text-center text-muted">
              Enter your email address and we'll email you a link to reset your password.
            </p>
            <div v-if="alertMessage" class="alert alert-success" role="alert">
              <p class="text-center mb-0">
                {{ alertMessage }}
              </p>
            </div>
            <ErrorSummary :error="error" />
            <form ref="form" class="needs-validation" :class="formWasValidated ? 'was-validated' : ''" novalidate @submit.prevent>
              <div class="form-group">
                <label for="emailAddress">Email</label>
                <input
                  v-model="emailAddress"
                  type="email"
                  class="form-control"
                  id="emailAddress"
                  placeholder="Email"
                  required
                  :disabled="isWorking"
                  @keyup.enter="submit"
                />
                <div class="invalid-feedback">
                  Please provide your email address.
                </div>
              </div>

              <button type="button" class="btn btn-primary btn-block" @click="submit" :disabled="isWorking" @keyup.enter="submit">
                <span v-if="isWorking" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Send Email Reset Link
              </button>
            </form>
          </div>
          <div class="card-footer text-center">
            <small class="text-muted">
              Already know your email and password?
              <router-link to="/signin" v-slot="{ href, navigate }">
                <a :href="href" @click="navigate">Sign In</a>
              </router-link>
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorSummary from "@/components/ErrorSummary.vue";

export default {
  components: {
    ErrorSummary,
  },
  data() {
    return {
      isWorking: false,
      formWasValidated: false,
      alertMessage: null,
      error: null,

      emailAddress: null,
    };
  },
  methods: {
    reset() {
      this.isWorking = false;
      this.formWasValidated = false;
      this.alertMessage = null;
    },
    async submit() {
      const payload = {
        emailAddress: this.emailAddress,
      };

      // reset
      this.reset();

      // validations
      if (!this.$refs.form.checkValidity()) {
        this.formWasValidated = true;
        return;
      }

      // send a password reset link
      this.isWorking = true;
      try {
        await this.$axios.post("/v1/signin/forgot-password", payload);
        this.alertMessage = "We've sent password reset instructions to your email address.";
      } catch (err) {
        this.error = err;
      } finally {
        this.isWorking = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  width: 400px;
  margin: 0 auto;
}
</style>
